// src/queries/pages/dashboard/userApiConfig.js

import { STALE_TIME, GC_TIME, QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const userConfig = {
  /* -------------------------------------------------------------------------- */
  /*                               FETCH OPERATIONS                             */
  /* -------------------------------------------------------------------------- */

  getAllUsers: {
    key: "getAllUsers",
    url: "/api/v1/users",
    method: "GET",
    options: {
      staleTime: STALE_TIME.REALTIME,
      gcTime: GC_TIME.NONE,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      keepPreviousData: true,
      retry: 2,
      meta: { description: "Fetch all active users for admin dashboard" },
    },
  },

  getUserById: {
    key: "getUserById",
    url: (id) => `/api/v1/users/${id}`,
    method: "GET",
    options: {
      staleTime: STALE_TIME.REALTIME,
      gcTime: GC_TIME.NONE,
      enabled: false,
      retry: 1,
      retryDelay: 1000,
      meta: { description: "Fetch single user by ID" },
    },
  },

  getStaffByName: {
    key: "getStaffByName",
    url: "/api/v1/users/staff",
    method: "GET",
    options: {
      staleTime: STALE_TIME.REALTIME,
      gcTime: GC_TIME.NONE,
      retry: 1,
      meta: { description: "Fetch staff data by name" },
    },
  },

  // TODO: pending pms-api implementation
  userManagementGetDeletedUsers: {
    key: "userManagementGetDeletedUsers",
    url: "/api/v1/users/deleted",
    method: "GET",
    options: {
      staleTime: STALE_TIME.REALTIME,
      gcTime: GC_TIME.NONE,
      refetchOnMount: true,
      keepPreviousData: true,
      meta: { description: "Fetch deleted users for admin management" },
    },
  },

  /* -------------------------------------------------------------------------- */
  /*                               CREATE OPERATIONS                            */
  /* -------------------------------------------------------------------------- */

  createUserByPmsAdmin: {
    key: "createUserByPmsAdmin",
    url: "/api/v1/users",
    method: "POST",
    options: {
      invalidateKeys: ["getAllUsers"],
      onSuccessMessage: "User created successfully",
      onErrorMessage: "Failed to create user",
      retry: false,
    },
  },

  /* -------------------------------------------------------------------------- */
  /*                                INVITE OPERATIONS                           */
  /* -------------------------------------------------------------------------- */

  // TODO: pending pms-api implementation
  inviteUser: {
    key: "inviteUser",
    url: "/api/v1/user-invites",
    method: "POST",
    options: {
      invalidateKeys: ["getAllUsers"],
      onSuccessMessage: "Invitation sent successfully",
      onErrorMessage: "Failed to send invitation",
      retry: false,
    },
  },

  // TODO: pending pms-api implementation
  createHotelOwnerInvite: {
    key: "createHotelOwnerInvite",
    url: "/api/v1/user-invites/hotel-owner",
    method: "POST",
    options: {
      invalidateKeys: ["getAllUsers"],
      onSuccessMessage: "Registration link sent successfully",
      onErrorMessage: "Failed to send registration link",
      retry: false,
    },
  },

  /* -------------------------------------------------------------------------- */
  /*                                UPDATE / DELETE                             */
  /* -------------------------------------------------------------------------- */

  updateUser: {
    key: "updateUser",
    url: (data) => `/api/v1/users/${data?.id}`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getAllUsers", "getProfileDetails"],
      meta: { description: "Update user profile" },
    },
  },

  /* -------------------------------------------------------------------------- */
  /*                      USER MANAGEMENT (ADMIN PANEL)                         */
  /* -------------------------------------------------------------------------- */

  // TODO: pending pms-api implementation
  userManagementSoftDeleteUser: {
    key: "userManagementSoftDeleteUser",
    url: (data) => `/api/v1/users/${data.id}`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getAllUsers", "userManagementGetDeletedUsers"],
      onSuccessMessage: "User soft-deleted by admin",
    },
  },

  // TODO: pending pms-api implementation
  userManagementRestoreUser: {
    key: "userManagementRestoreUser",
    url: (data) => `/api/v1/users/${data.id}/restore`,
    method: "PATCH",
    options: {
      invalidateKeys: ["getAllUsers", "userManagementGetDeletedUsers"],
      onSuccessMessage: "User restored by admin",
    },
  },

  // TODO: pending pms-api implementation
  userManagementHardDeleteUser: {
    key: "userManagementHardDeleteUser",
    url: (data) => `/api/v1/users/${data.id}/hard`,
    method: "DELETE",
    options: {
      invalidateKeys: ["getAllUsers", "userManagementGetDeletedUsers"],
      onSuccessMessage: "User permanently deleted by admin",
    },
  },

  forgotPassword: {
    key: "forgotPassword",
    url: "/api/v1/auth/forgot-password",
    method: "POST",
    options: {
      onSuccessMessage: "Password reset link sent successfully",
      onErrorMessage: "Failed to send password reset link",
    },
  },

  validateResetToken: {
    key: "validateResetToken",
    url: "/api/v1/auth/validate-token",
    method: "GET",
    options: {
      retry: false,
    },
  },

  resetPassword: {
    key: "resetPassword",
    url: "/api/v1/auth/reset-password",
    method: "POST",
    options: {
      onSuccessMessage: "Password reset successfully",
      onErrorMessage: "Failed to reset password",
    },
  },
};
